import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import { VIEWING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH } from '../RentalPortalViewingProfileHeaderInfoItems.constants'

function ViewingProfileHeaderInfoItemsSkeleton({ className }) {
  return (
    <>
      {Array.from({
        length: VIEWING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH,
      }).map((_, index) => (
        <EntityProfileHeaderInfoItemBase
          isLoading
          className={className}
          key={index}
        />
      ))}
    </>
  )
}

export default ViewingProfileHeaderInfoItemsSkeleton
